/* Drömkudden: gemensamt script för dk-sektionerna */
(function () {
  if (window.DK) return;
  var DK = (window.DK = {});
  var DAY = 864e5;

  /* Delad nedräkning: samma för alla besökare.
     Räknar ner från start + firstDays, sedan börjar den om på cycleDays varje gång.
     Allt räknas från en fast starttid, inget sparas i webbläsaren. */
  DK.remaining = function (startIso, firstDays, cycleDays) {
    var start = Date.parse(startIso);
    if (isNaN(start)) start = Date.parse('2026-10-11T00:00:00+02:00');
    var first = Math.max(1, firstDays || 9) * DAY;
    var cycle = Math.max(1, cycleDays || 7) * DAY;
    var now = Date.now();
    var firstEnd = start + first;
    if (now < start) return first;
    if (now < firstEnd) return firstEnd - now;
    return cycle - ((now - firstEnd) % cycle);
  };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  DK.format = function (ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + 't ' + pad(m) + 'm ' + pad(s) + 's';
  };
  function tickTimers() {
    document.querySelectorAll('[data-dk-timer]').forEach(function (el) {
      var ms = DK.remaining(el.dataset.start, +el.dataset.first, +el.dataset.cycle);
      var out = el.querySelector('[data-dk-timer-out]') || el;
      if (out.hasAttribute('data-dk-timer-boxes')) {
        var s = Math.floor(ms / 1000);
        var parts = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
        out.querySelectorAll('b').forEach(function (b, i) { var v = pad(parts[i]); if (b.textContent !== v) b.textContent = v; });
      } else {
        out.textContent = DK.format(ms);
      }
    });
  }
  /* Toppbannern: texten [timer] byts mot samma nedräkning som på produktsidan.
     Temats banner kan bara visa vanlig text, så markören fylls i här. */
  function initBannerTimers() {
    var ref = document.querySelector('.dkp__timer[data-dk-timer]');
    document.querySelectorAll('.announcement-bar__message').forEach(function (msg) {
      var walker = document.createTreeWalker(msg, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) if (walker.currentNode.nodeValue.indexOf('[timer]') > -1) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var parts = node.nodeValue.split('[timer]');
        var span = document.createElement('span');
        span.className = 'dk-banner-timer';
        span.setAttribute('data-dk-timer', '');
        span.dataset.start = ref ? ref.dataset.start : '2026-10-11T00:00:00+02:00';
        span.dataset.first = ref ? ref.dataset.first : '9';
        span.dataset.cycle = ref ? ref.dataset.cycle : '7';
        var out = document.createElement('span');
        out.setAttribute('data-dk-timer-out', '');
        out.setAttribute('data-dk-timer-boxes', '');
        out.className = 'dk-bt-boxes';
        ['d', 't', 'm', 's'].forEach(function (u) {
          var box = document.createElement('span');
          box.className = 'dk-bt-box';
          box.innerHTML = '<b>00</b><small>' + u + '</small>';
          out.appendChild(box);
        });
        span.appendChild(out);
        var frag = document.createDocumentFragment();
        frag.appendChild(document.createTextNode(parts[0]));
        frag.appendChild(span);
        frag.appendChild(document.createTextNode(parts.slice(1).join('')));
        node.parentNode.replaceChild(frag, node);
      });
    });
  }
  setInterval(tickTimers, 1000);
  document.addEventListener('DOMContentLoaded', function () { initBannerTimers(); tickTimers(); });
  document.addEventListener('shopify:section:load', function () { initBannerTimers(); });
  DK.tickTimers = tickTimers;

  /* Skickas senast: nästa vardag */
  DK.shipDate = function (el) {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var txt = d.toLocaleDateString('sv-SE', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
    el.textContent = txt.charAt(0).toUpperCase() + txt.slice(1);
  };

  /* Scroller med pilar + progress */
  DK.initScroller = function (root) {
    root.querySelectorAll('[data-dk-scroller]').forEach(function (sc) {
      if (sc.dataset.dkReady) return;
      sc.dataset.dkReady = '1';
      var id = sc.dataset.dkScroller;
      var prev = root.querySelector('[data-dk-prev="' + id + '"]');
      var next = root.querySelector('[data-dk-next="' + id + '"]');
      var bar = root.querySelector('[data-dk-bar="' + id + '"]');
      function step() { var c = sc.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; }
      function update() {
        var max = sc.scrollWidth - sc.clientWidth;
        if (prev) prev.disabled = sc.scrollLeft <= 2;
        if (next) next.disabled = sc.scrollLeft >= max - 2;
        if (bar) {
          var w = Math.max(12, (sc.clientWidth / sc.scrollWidth) * 100);
          bar.style.width = w + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (sc.scrollLeft / max) * (100 / w * 100 - 100) : 0) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { sc.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { sc.scrollBy({ left: step(), behavior: 'smooth' }); });
      sc.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  /* Lägg i varukorgen och öppna drawern */
  DK.addToCart = function (items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Fel');
        if (drawer && res.j.sections && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: items[0].id, sections: res.j.sections });
        } else if (window.timber && timber.RightDrawer && document.getElementById('CartDrawer')) {
          // Debutify: öppna temats kundvagnslåda och ladda om innehållet
          timber.RightDrawer.open();
          if (window.theme && theme.ajaxCart && theme.ajaxCart.load) theme.ajaxCart.load();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (e) { alert(e.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  };

  /* Rullande rad som går att dra: rullar åt vänster av sig själv, kan dras fram och tillbaka
     med finger eller mus, fortsätter rulla en stund efter att man släppt. Innehållet ligger
     dubbelt i spåret så att det loopar sömlöst. */
  DK.initMarquee = function (root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-dk-mq]').forEach(function (box) {
      if (box.dataset.dkReady) return;
      box.dataset.dkReady = '1';
      var track = box.querySelector('[data-dk-mq-track]');
      if (!track) return;
      var secs = parseFloat(box.dataset.secs) || 3.5;
      var x = 0, half = 0, speed = 60, last = 0, resumeAt = 0;
      var dragging = false, startX = 0, startOff = 0, moved = 0, pid = null;
      function measure() {
        half = track.scrollWidth / 2;
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        speed = first ? (first.getBoundingClientRect().width + gap) / secs : 60;
      }
      function wrap() { if (half > 0) { x = x % half; if (x > 0) x -= half; } }
      function frame(t) {
        if (!last) last = t;
        var dt = Math.min(64, t - last); last = t;
        if (!dragging && !reduce && t >= resumeAt && !document.hidden) x -= speed * dt / 1000;
        wrap();
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        requestAnimationFrame(frame);
      }
      measure();
      window.addEventListener('resize', measure);
      track.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', measure, { once: true }); });
      requestAnimationFrame(frame);

      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; moved = 0; startX = e.clientX; startOff = x; pid = e.pointerId;
        box.classList.add('is-dragging');
      });
      box.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pid) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4 && !box.hasPointerCapture(pid)) { try { box.setPointerCapture(pid); } catch (err) {} }
        moved = Math.max(moved, Math.abs(dx));
        x = startOff + dx;
        wrap();
      });
      function end(e) {
        if (!dragging || (e && e.pointerId !== pid)) return;
        dragging = false; pid = null;
        resumeAt = performance.now() + 900;
        box.classList.remove('is-dragging');
      }
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
      box.addEventListener('lostpointercapture', function (e) { if (e.target === box) end(e); });
      box.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      box.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  };

  document.addEventListener('DOMContentLoaded', function () { DK.initScroller(document); DK.initMarquee(document); });
  document.addEventListener('shopify:section:load', function (e) { DK.initScroller(e.target); DK.initMarquee(e.target); tickTimers(); });
})();

/* Reservationstimer i varukorgslådan (templates/cart.ajax.liquid, [data-dk-reserv]).
   Räknar ner 5:00 från första gången lådan visas med varor. Tiden sparas för besöket
   (sessionStorage) så att den inte börjar om varje gång lådan öppnas; när den når 0:00 börjar den om. */
(function () {
  var LANGD = 5 * 60 * 1000, KEY = 'dkReservStart';
  function start() {
    var s = 0;
    try { s = +sessionStorage.getItem(KEY) || 0; } catch (e) {}
    if (!s || Date.now() - s >= LANGD) { s = Date.now(); try { sessionStorage.setItem(KEY, String(s)); } catch (e) {} }
    return s;
  }
  function tick() {
    var el = document.querySelectorAll('[data-dk-reserv-t]');
    if (!el.length) return;
    var kvar = Math.max(0, LANGD - (Date.now() - start()));
    var sek = Math.ceil(kvar / 1000), txt = Math.floor(sek / 60) + ':' + (sek % 60 < 10 ? '0' : '') + (sek % 60);
    for (var i = 0; i < el.length; i++) if (el[i].textContent !== txt) el[i].textContent = txt;
  }
  setInterval(tick, 1000);
  new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true });
})();
